import type * as Types from '../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type HotelStaticByJoyPlaceQueryVariables = Types.Exact<{
  idObject: Types.AccommodationCatalogPropertyIdentifierInput;
}>;

export type HotelStaticByJoyPlaceQuery = {
  __typename?: 'Query';
  accommodationCatalogPropertyById: {
    __typename?: 'AccommodationCatalogProperty';
    joyPlaceId: string;
    name: string;
    plainTextLongDescription: string;
    starRating?: number | null;
    userRating?: { __typename?: 'UserRating'; ratingCount?: number | null; ratingValue?: number | null } | null;
    facilities: Array<{ __typename?: 'AccommodationCatalogFacilityOrAmenity'; label: string }>;
    photos: Array<{ __typename?: 'AccommodationCatalogPhoto'; url: string }>;
    location: { __typename?: 'AccommodationCatalogLocation'; latitude?: number | null; longitude?: number | null };
    address?: {
      __typename?: 'AccommodationCatalogPropertyAddress';
      city?: string | null;
      country?: string | null;
      postalCode?: string | null;
      state?: string | null;
      street?: string | null;
    } | null;
  };
};

export type EventAccommodationByJoyPlaceQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type EventAccommodationByJoyPlaceQuery = {
  __typename?: 'Query';
  eventById?: {
    __typename?: 'Event';
    id: string;
    accommodationPlacesV2: Array<{
      __typename?: 'AccommodationPlaceV2';
      id: string;
      joyPlaceId?: string | null;
      name?: string | null;
      customName?: string | null;
      isPhotoHidden?: boolean | null;
      userNote?: string | null;
      description?: string | null;
      customPhoto?: { __typename?: 'Photo'; id: string; altTag?: string | null; url: string } | null;
      photo?: { __typename?: 'Photo'; id: string; altTag?: string | null; url: string } | null;
    }>;
    places: Array<{
      __typename?: 'EventPlace';
      id?: string | null;
      googlePlaceId?: string | null;
      type: Types.EventPlaceType;
      name: string;
      displayAddress: string;
      latitude?: number | null;
      longitude?: number | null;
      city?: string | null;
      stateProvince?: string | null;
      country?: string | null;
      countryCode?: string | null;
    }>;
  } | null;
};

export const HotelStaticByJoyPlaceDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'HotelStaticByJoyPlace' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'idObject' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'AccommodationCatalogPropertyIdentifierInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accommodationCatalogPropertyById' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'idObject' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'idObject' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'joyPlaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'plainTextLongDescription' } },
                { kind: 'Field', name: { kind: 'Name', value: 'starRating' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'userRating' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'ratingCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ratingValue' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'facilities' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'label' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'photos' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'location' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useHotelStaticByJoyPlaceQuery__
 *
 * To run a query within a React component, call `useHotelStaticByJoyPlaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useHotelStaticByJoyPlaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHotelStaticByJoyPlaceQuery({
 *   variables: {
 *      idObject: // value for 'idObject'
 *   },
 * });
 */
export function useHotelStaticByJoyPlaceQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<HotelStaticByJoyPlaceQuery, HotelStaticByJoyPlaceQueryVariables>) {
  return ApolloReactHooks.useQuery<HotelStaticByJoyPlaceQuery, HotelStaticByJoyPlaceQueryVariables>(HotelStaticByJoyPlaceDocument, baseOptions);
}
export function useHotelStaticByJoyPlaceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HotelStaticByJoyPlaceQuery, HotelStaticByJoyPlaceQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<HotelStaticByJoyPlaceQuery, HotelStaticByJoyPlaceQueryVariables>(HotelStaticByJoyPlaceDocument, baseOptions);
}
export type HotelStaticByJoyPlaceQueryHookResult = ReturnType<typeof useHotelStaticByJoyPlaceQuery>;
export type HotelStaticByJoyPlaceLazyQueryHookResult = ReturnType<typeof useHotelStaticByJoyPlaceLazyQuery>;
export type HotelStaticByJoyPlaceQueryResult = Apollo.QueryResult<HotelStaticByJoyPlaceQuery, HotelStaticByJoyPlaceQueryVariables>;
export const EventAccommodationByJoyPlaceDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EventAccommodationByJoyPlace' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventById' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accommodationPlacesV2' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'joyPlaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'customName' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customPhoto' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'altTag' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'photo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'altTag' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isPhotoHidden' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userNote' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'places' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'googlePlaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayAddress' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useEventAccommodationByJoyPlaceQuery__
 *
 * To run a query within a React component, call `useEventAccommodationByJoyPlaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventAccommodationByJoyPlaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventAccommodationByJoyPlaceQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useEventAccommodationByJoyPlaceQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<EventAccommodationByJoyPlaceQuery, EventAccommodationByJoyPlaceQueryVariables>,
) {
  return ApolloReactHooks.useQuery<EventAccommodationByJoyPlaceQuery, EventAccommodationByJoyPlaceQueryVariables>(EventAccommodationByJoyPlaceDocument, baseOptions);
}
export function useEventAccommodationByJoyPlaceLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventAccommodationByJoyPlaceQuery, EventAccommodationByJoyPlaceQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<EventAccommodationByJoyPlaceQuery, EventAccommodationByJoyPlaceQueryVariables>(EventAccommodationByJoyPlaceDocument, baseOptions);
}
export type EventAccommodationByJoyPlaceQueryHookResult = ReturnType<typeof useEventAccommodationByJoyPlaceQuery>;
export type EventAccommodationByJoyPlaceLazyQueryHookResult = ReturnType<typeof useEventAccommodationByJoyPlaceLazyQuery>;
export type EventAccommodationByJoyPlaceQueryResult = Apollo.QueryResult<EventAccommodationByJoyPlaceQuery, EventAccommodationByJoyPlaceQueryVariables>;
